var map = {
	"./20ideas.svg": 475,
	"./away.svg": 476,
	"./bookmark-a11y.svg": 477,
	"./bookmark-active-a11y.svg": 478,
	"./bookmark-active.svg": 479,
	"./bookmark.svg": 480,
	"./calendar.svg": 481,
	"./card-blue.svg": 482,
	"./card-green.svg": 483,
	"./card-red.svg": 484,
	"./card.svg": 485,
	"./check-big.svg": 486,
	"./check-small.svg": 487,
	"./check.svg": 488,
	"./checkmark.svg": 489,
	"./chevron-2.svg": 490,
	"./chevron-24-right.svg": 491,
	"./chevron-right-a11y.svg": 492,
	"./chevron-right.svg": 493,
	"./chevron.svg": 494,
	"./close-2.svg": 495,
	"./close-3.svg": 496,
	"./close-a11y.svg": 497,
	"./close-circle.svg": 498,
	"./close.svg": 499,
	"./copy-a11y.svg": 500,
	"./copy.svg": 501,
	"./corner-right.svg": 502,
	"./corner-top.svg": 503,
	"./crown.svg": 504,
	"./dots-column.svg": 505,
	"./dots.svg": 506,
	"./download.svg": 507,
	"./edit.svg": 508,
	"./email.svg": 509,
	"./enter.svg": 510,
	"./eye-a11y.svg": 511,
	"./eye-close.svg": 512,
	"./eye-open.svg": 513,
	"./eye.svg": 514,
	"./filter.svg": 515,
	"./gallery-a11y.svg": 516,
	"./gallery.svg": 517,
	"./info.svg": 518,
	"./list.svg": 519,
	"./lock.svg": 520,
	"./logo.svg": 521,
	"./marusia-vk.svg": 522,
	"./minus.svg": 523,
	"./mir.svg": 524,
	"./news.svg": 525,
	"./next.svg": 526,
	"./pause-large.svg": 527,
	"./pause.svg": 528,
	"./philips.svg": 529,
	"./pin.svg": 530,
	"./play-big.svg": 531,
	"./play-large.svg": 532,
	"./play.svg": 533,
	"./plus-one.svg": 534,
	"./plus.svg": 535,
	"./profile-bookmark.svg": 536,
	"./profile-info.svg": 537,
	"./profile-logout.svg": 538,
	"./profile-notifications.svg": 539,
	"./profile-subscription.svg": 540,
	"./promo.svg": 541,
	"./restart.svg": 542,
	"./rewind.svg": 543,
	"./rustore.svg": 544,
	"./salut-speech.svg": 545,
	"./search.svg": 546,
	"./share-a11y.svg": 547,
	"./share.svg": 548,
	"./shield.svg": 549,
	"./sort.svg": 550,
	"./speed-1.5x.svg": 551,
	"./speed-1x.svg": 552,
	"./switch-big.svg": 553,
	"./switch.svg": 554,
	"./volume-fill.svg": 555,
	"./volume-full.svg": 556,
	"./volume-half.svg": 557,
	"./volume-off.svg": 558,
	"./wifi-bestEmployers.svg": 559,
	"./wifi-default.svg": 560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;